import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './AnswerIncorrectIndicator.css'

class AnswerIncorrectIndicator extends React.Component {
  render () {
    let {id, children} = this.props

    const outerClasses = classNames({
      'hw-answer-incorrect-indicator': true,
      [styles.answer_incorrect_indicator]: true
    })
    const wrapperClasses = classNames({
      'hw-answer-incorrect-indicator-wrapper': true,
      [styles.answer_incorrect_indicator_wrapper]: true
    })
    const indicatorTextClasses = classNames({
      'hw-answer-incorrect-indicator-text': true,
      [styles.answer_incorrect_indicator_text]: true
    })

    return (<span className={outerClasses} id={id}>
      <span className={wrapperClasses} >
        <span className={indicatorTextClasses}>{children}</span>
      </span>
    </span>)
  }
}

AnswerIncorrectIndicator.propTypes = {
  id: PropTypes.string,
  children: PropTypes.string
}

AnswerIncorrectIndicator.defaultProps = {
  children: 'Incorrect'
}

export default AnswerIncorrectIndicator



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/AnswerIncorrectIndicator/index.js